/*
 * @Author: shanshan.hu
 * @FilePath: \cbest-welfare-erp-h5\src\views\MallManagement\components\storeProductQuery.js
 */
import { Form, Input, Button, Row, Col, message } from 'antd'
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import service from '../../../@services'
import { useEffect } from 'react'

export default function StoreProductQuery({ name, value, onChange }) {
  const [form] = Form.useForm()
  // 默认值
  const setDefault = val => {
    form.setFieldsValue({
      storeId: val.id
    })
  }
  const searchByBusinessId = async () => {
    form.validateFields().then(async value => {
      if (!value) return
      let params = form.getFieldsValue()
      const res = await service.mallManagement.searchProductCode(params)
      let temData
      res && res.length > 0 ? (temData = res[0]) : (temData = null)
      if (temData) {
        onChange({
          ...temData,
          ...form.getFieldsValue()
        })
      } else {
        message.error('未查询到数据')
      }
    })
  }
  const changeStoreFn = () => {
    onChange({ name: '' })
  }
  useEffect(() => {
    form.setFieldsValue(value)
  }, [value])
  return (
    <Form form={form} labelCol={{ span: 5 }}>
      <Form.Item name='storeId' label='所属门店' rules={[{ required: true }]}>
        <ShopSelect
          keyVal='id'
          OnOptionsLoad={setDefault}
          onChange={changeStoreFn}
          style={{ width: '260px' }}
        />
      </Form.Item>
      <Row>
        <Col offset={1} flex={1}>
          <Form.Item
            name='productInfo'
            label='商品编码'
            style={{ margin: 0 }}
            rules={[{ required: true, message: '请输入商户编码' }]}>
            <Input style={{ width: 260 }} placeholder='请输入' />
          </Form.Item>
        </Col>
        <Col offset={1}>
          <Button onClick={searchByBusinessId}>查询</Button>
        </Col>
      </Row>
    </Form>
  )
}
